var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareIconStudent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.460145 11.8188C0.238562 11.589 0.186703 11.2442 0.330908 10.9594L1.03241 9.57402C2.69268 6.2952 6.05563 4.22856 9.73084 4.22856H10.0757C10.1009 3.68218 10.1334 3.13605 10.1731 2.59032L10.241 1.65969C10.2961 0.902866 11.14 0.479799 11.7795 0.888381C13.8771 2.22874 15.7007 3.95583 17.153 5.97759L17.6091 6.61253C17.797 6.874 17.797 7.22618 17.6091 7.48766L17.153 8.1226C15.7007 10.1444 13.8771 11.8714 11.7795 13.2118C11.14 13.6204 10.2961 13.1973 10.241 12.4405L10.1731 11.5099C10.1256 10.8581 10.0886 10.2058 10.0619 9.55324C7.91207 9.49117 5.76486 9.92509 3.7915 10.8359L1.31431 11.9792C1.02447 12.1129 0.681728 12.0486 0.460145 11.8188ZM2.67839 9.69755L3.16291 9.47393C5.57405 8.3611 8.21958 7.89129 10.8447 8.09292C11.227 8.12228 11.5256 8.43528 11.5369 8.81855C11.5624 9.67991 11.6065 10.5409 11.6692 11.4008L11.6746 11.4753C13.3181 10.3136 14.7583 8.88521 15.9348 7.24747L16.0766 7.05009L15.9348 6.85272C14.7583 5.21497 13.3181 3.78658 11.6746 2.62492L11.6692 2.69938C11.6132 3.46699 11.5721 4.2354 11.5458 5.0042C11.532 5.4082 11.2005 5.72856 10.7962 5.72856L9.73084 5.72856C6.83352 5.72856 4.16555 7.24646 2.67839 9.69755Z",
    fill: "#0B74BB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIconStudent);
export default __webpack_public_path__ + "static/media/ShareIconStudent.5c360f758d742f42fe105e9026a60b7c.svg";
export { ForwardRef as ReactComponent };